import { render, staticRenderFns } from "./ModalRundownTakeOver.vue?vue&type=template&id=61fa7b6b&"
import script from "./ModalRundownTakeOver.vue?vue&type=script&lang=js&"
export * from "./ModalRundownTakeOver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports